module.exports = __webpack_public_path__ + "img/gallery05.faf30cd9.png";